import { Body1 } from '@cian/ui-kit';
import React from 'react';

import { NBSP } from 'shared/common/constants';

import { programGuideImages } from '../mortgage-assets';
import styles from './styles.css';

export interface IProgramGuidePage {
  title: string;
  image: {
    light: string;
    dark: string;
  };
  description: React.ReactNode;
}

export const PROGRAM_GUIDE_PAGES: IProgramGuidePage[] = [
  {
    title: 'Семейная',
    image: {
      light: programGuideImages.family.light,
      dark: programGuideImages.family.dark,
    },
    description: (
      <>
        <Body1 color="text-primary-default">
          Для семей с детьми. Ставка и лимит кредита зависят от количества детей и региона:
        </Body1>
        <ul className={styles['rates-list']}>
          <li>
            <Body1 color="text-primary-default">
              1 ребёнок — 10% в регионах / 12% в Москве, МО, Санкт-Петербурге и ЛО;
            </Body1>
          </li>
          <li>
            <Body1 color="text-primary-default">2 ребёнка — 8% / 10%;</Body1>
          </li>
          <li>
            <Body1 color="text-primary-default">3 ребёнка — 6% / 8%;</Body1>
          </li>
          <li>
            <Body1 color="text-primary-default">4 ребёнка — 4% / 6%;</Body1>
          </li>
          <li>
            <Body1 color="text-primary-default">5 и более — 2% / 4%.</Body1>
          </li>
        </ul>
        <Body1 color="text-primary-default">
          Подойдёт семьям, в которых есть хотя бы один ребёнок младше 7 лет на дату заключения кредитного договора, за
          исключением семей с детьми-инвалидами, для которых это условие не требуется.
        </Body1>
      </>
    ),
  },
  {
    title: 'ИТ-ипотека',
    image: {
      light: programGuideImages.it.light,
      dark: programGuideImages.it.dark,
    },
    description: (
      <>
        <Body1 color="text-primary-default">
          {`Льготная программа${NBSP}для${NBSP}тех, кто${NBSP}работает в${NBSP}ИТ-компаниях. Исключение${NBSP}— Москва и${NBSP}Санкт-Петербург: если вы сотрудник местной компании или${NBSP}хотите купить квартиру в${NBSP}столицах, программа не${NBSP}подойдёт.`}
          <br />
          <br />
        </Body1>
        <Body1 color="text-primary-default">{`Ставка${NBSP}— 6%. Есть требования по${NBSP}доходу:`}</Body1>
        <ul className={styles.list}>
          <li>
            <Body1 color="text-primary-default">
              {`от${NBSP}150${NBSP}000${NBSP}₽${NBSP}— для${NBSP}компаний из${NBSP}Московской и${NBSP}Ленинградской областей`}
            </Body1>
          </li>
          <li>
            <Body1 color="text-primary-default">
              {`от${NBSP}90${NBSP}000${NBSP}₽${NBSP}— для${NBSP}компаний из${NBSP}других регионов`}
            </Body1>
          </li>
        </ul>
      </>
    ),
  },
  {
    title: 'Базовая',
    image: {
      light: programGuideImages.base.light,
      dark: programGuideImages.base.dark,
    },
    description: (
      <Body1 color="text-primary-default">
        {`Кредит на${NBSP}недвижимость по${NBSP}рыночной ставке, который${NBSP}может${NBSP}взять любой гражданин РФ${NBSP}от${NBSP}18${NBSP}до${NBSP}75${NBSP}лет.`}
      </Body1>
    ),
  },
];
